module.exports = __webpack_public_path__ + "static/media/1piechart.1a838792.png";